import { makeAutoObservable } from "mobx";

const DEFAULT_BEDROOMS = Array.from({ length: 10 }, (_, index) => ({
    id: index + 1,
    value: index + 1
}));

const DEFAULT_BUILDINGS = [
    { id: 1, value: 'Новостройка' },
    { id: 2, value: 'Старый фонд' },
    { id: 3, value: 'Иное' },
];

const DEFAULT_FLOORS = Array.from({ length: 20 }, (_, index) => ({
    id: index + 1,
    value: index + 1
}));

const DEFAULT_ROOMS = Array.from({ length: 10 }, (_, index) => ({
    id: index + 1,
    value: String(index + 1)
}));

const DEFAULT_REPAIRS = [
    { id: 1, value: 'Дизайнерский' },
    { id: 2, value: 'Евро' },
    { id: 3, value: 'Косметический' },
    { id: 4, value: 'Без ремонта' },
];

const DEFAULT_HEATINGS = [
    { id: 1, value: 'Индивидуальное' },
    { id: 2, value: 'Центральное' },
    { id: 3, value: 'Печное (форсуночное)' },
];

const DEFAULT_PARKINGS = [
    { id: 1, value: 'Подземная' },
    { id: 2, value: 'Открытая во дворе' },
    { id: 3, value: 'Отсутствует' },
];

const DEFAULT_AREAS = [
    {
        id: 3,
        value: 'Никольский собор',
        description: 'Тихий исторический центр рядом со Свято-Никольским собором и парком',
        priority: 80,
        color: 'rgba(196, 132, 92, 0.37)'
    },
    {
        id: 4,
        value: 'Каскадная лестница',
        description: 'Один из лучших входов в парк и быстрый выход к прогулочным маршрутам',
        priority: 85,
        color: 'rgba(222, 170, 102, 0.42)'
    },
    {
        id: 5,
        value: 'Санаторий Москва',
        description: 'Уютный курортный район рядом с терренкурами и маршрутами парка',
        priority: 70,
        color: 'rgba(205, 140, 140, 0.35)'
    },
    {
        id: 6,
        value: 'Комсомольский парк',
        description: 'Рядом рынок, магазины и зелёная зона для прогулок',
        priority: 60,
        color: 'rgba(121, 168, 120, 0.38)'
    },
    {
        id: 7,
        value: 'Старое озеро',
        description: 'Набережная, вода и приятные прогулки рядом',
        priority: 55,
        color: 'rgba(102, 166, 154, 0.35)'
    },
    {
        id: 8,
        value: 'Верхний парк',
        description: 'Тишина, виды и быстрый доступ к Долине роз',
        priority: 75,
        color: 'rgba(156, 181, 126, 0.4)'
    },
    {
        id: 9,
        value: 'Курортный центр',
        description: 'Колоннада, бульвар и главная курортная жизнь рядом',
        priority: 100,
        color: 'rgba(214, 176, 94, 0.4)'
    },
    {
        id: 10,
        value: 'Другие',
        description: '',
        priority: 0,
        color: 'rgba(0, 150, 255, 0.2)'
    },
];

export default class AddStore {
    constructor() {
        this._bedrooms = DEFAULT_BEDROOMS
        this._buildings = DEFAULT_BUILDINGS
        this._floors = DEFAULT_FLOORS
        this._rooms = DEFAULT_ROOMS
        this._repairs = DEFAULT_REPAIRS
        this._heatings = DEFAULT_HEATINGS
        this._parkings = DEFAULT_PARKINGS
        this._areas = DEFAULT_AREAS

        this._paramsLoaded = false
        this._paramsFromServer = false

        this._rules = [
            { id: 1, value: 'Можно с животными' },
            { id: 2, value: 'Можно с детьми' },
            { id: 3, value: 'Можно курить' },
        ]

        this._adds = []
        this._mapAdds = []
        this._blogs = []
        this._places = []
        this._page = 1
        this._totalCount = 0
        this._limit = 20

        this._reviews = []

        this._selectedBuilding = {}
        this._selectedBedroom = {}
        this._selectedFloor = {}
        this._selectedRoom = {}
        this._selectedRepair = {}
        this._selectedHeating = {}
        this._selectedParking = {}
        this._selectedArea = {}
        this._selectedInfo = {}
        this._selectedAnimal = {}
        this._selectedChildren = {}
        this._selectedSmoking = {}

        this._catalogScrollY = 0
        this._shouldRestoreCatalog = false

        this._mapSearchState = null
        this._shouldRestoreMapSearch = false

        makeAutoObservable(this)
    }

    //////////////////////////////////SET ANYTHING////////////////////////////////////////////////

    setBedrooms(bedrooms) {
        this._bedrooms = bedrooms
    }

    setBuildings(buildings) {
        this._buildings = buildings
    }

    setAreas(areas) {
        this._areas = areas
    }

    setFloors(floors) {
        this._floors = floors
    }

    setReviews(reviews) {
        this._reviews = reviews
    }

    setRooms(rooms) {
        this._rooms = rooms
    }

    setRepairs(repairs) {
        this._repairs = repairs
    }

    setHeatings(heatings) {
        this._heatings = heatings
    }

    setParkings(parkings) {
        this._parkings = parkings
    }

    setParamsLoaded(value) {
        this._paramsLoaded = value
    }

    setParamsFromServer(value) {
        this._paramsFromServer = value
    }

    setAdds(adds) {
        this._adds = adds
    }

    setMapAdds(adds) {
        this._mapAdds = adds
    }

    setBlogs(blogs) {
        this._blogs = blogs
    }

    setPlaces(places) {
        this._places = places
    }

    setPage(page) {
        this._page = page
    }

    setCatalogScrollY(value) {
        this._catalogScrollY = value
    }

    setShouldRestoreCatalog(value) {
        this._shouldRestoreCatalog = value
    }

    setMapSearchState(state) {
        this._mapSearchState = state
    }

    setShouldRestoreMapSearch(value) {
        this._shouldRestoreMapSearch = value
    }

    //////////////////////////////////SET SELECTED////////////////////////////////////////////////

    setSelectedBuilding(building) {
        this._selectedBuilding = building
    }

    setSelectedBedroom(bedroom) {
        this._selectedBedroom = bedroom
    }

    setSelectedFloor(floor) {
        this._selectedFloor = floor
    }

    setSelectedRoom(room) {
        this._selectedRoom = room
    }

    setSelectedRepair(repair) {
        this._selectedRepair = repair
    }

    setSelectedHeating(heating) {
        this._selectedHeating = heating
    }

    setSelectedParking(parking) {
        this._selectedParking = parking
    }

    setSelectedArea(area) {
        this._selectedArea = area
    }

    setTotalCount(count) {
        this._totalCount = count
    }

    //////////////////////////////////GET ANYTHING////////////////////////////////////////////////

    get bedrooms() {
        return this._bedrooms
    }

    get buildings() {
        return this._buildings
    }

    get areas() {
        return this._areas
    }

    get floors() {
        return this._floors
    }

    get reviews() {
        return this._reviews
    }

    get rooms() {
        return this._rooms
    }

    get repairs() {
        return this._repairs
    }

    get heatings() {
        return this._heatings
    }

    get parkings() {
        return this._parkings
    }

    get paramsLoaded() {
        return this._paramsLoaded
    }

    get paramsFromServer() {
        return this._paramsFromServer
    }

    get rules() {
        return this._rules
    }

    get adds() {
        return this._adds
    }

    get mapAdds() {
        return this._mapAdds
    }

    get blogs() {
        return this._blogs
    }

    get places() {
        return this._places
    }

    get catalogScrollY() {
        return this._catalogScrollY
    }

    get shouldRestoreCatalog() {
        return this._shouldRestoreCatalog
    }

    get mapSearchState() {
        return this._mapSearchState
    }

    get shouldRestoreMapSearch() {
        return this._shouldRestoreMapSearch
    }

    get selectedBuilding() {
        return this._selectedBuilding
    }

    get selectedBedroom() {
        return this._selectedBedroom
    }

    get selectedFloor() {
        return this._selectedFloor
    }

    get selectedRoom() {
        return this._selectedRoom
    }

    get selectedRepair() {
        return this._selectedRepair
    }

    get selectedHeating() {
        return this._selectedHeating
    }

    get selectedParking() {
        return this._selectedParking
    }

    get selectedAnimal() {
        return this._selectedAnimal
    }

    get selectedChildren() {
        return this._selectedChildren
    }

    get selectedSmoking() {
        return this._selectedSmoking
    }

    get selectedInfo() {
        return this._selectedInfo
    }

    get selectedArea() {
        return this._selectedArea
    }

    get totalCount() {
        return this._totalCount
    }

    get page() {
        return this._page
    }

    get limit() {
        return this._limit
    }
}